import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  standalone: true,
  selector: 'app-info-item',
  imports: [CommonModule, SkeletonModule],
  templateUrl: './info-item.component.html',
})
export class InfoItemComponent {
  @Input() label!: string;
  @Input() value: unknown = '-';
  @Input() loading = false;

  hasValue(val: unknown): boolean {
    return val !== null && val !== undefined && val !== '';
  }
}
